module.exports = __webpack_public_path__ + "static/media/1-jul12dec12.b4a0f4bb.pdf";